// IBKR import operations API client.
//
// TRA-306 exposes user-scoped DRF endpoints under /api/v1/ibkr. Browser code
// must keep using axiosClient so authentication, base URL handling, and global
// request conventions stay centralized.

import axiosClient from './axiosClient.js';

const IMPORTS_BASE = '/ibkr/imports';
const TRADES_BASE = '/ibkr/trades';
const SILENT_CONFIG = { skipGlobalErrorHandler: true };

const getOps = async (path, config = {}) => {
  const { data } = await axiosClient.get(path, { ...SILENT_CONFIG, ...config });
  return data;
};

const postOps = async (path, body = {}, config = {}) => {
  const { data } = await axiosClient.post(path, body, { ...SILENT_CONFIG, ...config });
  return data;
};

export const getIbkrImports = (params = {}) => getOps(`${IMPORTS_BASE}/`, { params });

export const getIbkrImportLedger = (importVersion, params = {}) =>
  getOps(`${IMPORTS_BASE}/${encodeURIComponent(importVersion)}/ledger/`, { params });

export const getIbkrTradeDetail = (tradeId) =>
  getOps(`${TRADES_BASE}/${encodeURIComponent(tradeId)}/detail/`);

export const rollbackIbkrImports = (body = {}) => postOps(`${IMPORTS_BASE}/rollback/`, body);

export const rollbackIbkrImportVersion = (importVersion, body = {}) =>
  postOps(`${IMPORTS_BASE}/${encodeURIComponent(importVersion)}/rollback/`, body);

export const deleteIbkrTrade = (tradeId, body = {}) => {
  const path = `${TRADES_BASE}/${encodeURIComponent(tradeId)}/delete/`;
  return postOps(path, body);
};

export const getIbkrImportsRefreshStatus = (params = {}) =>
  getOps(`${IMPORTS_BASE}/refresh-status/`, { params });

export const getIbkrImportRefreshStatus = (importVersion, params = {}) =>
  getOps(`${IMPORTS_BASE}/${encodeURIComponent(importVersion)}/refresh-status/`, { params });

export default {
  getIbkrImports,
  getIbkrImportLedger,
  getIbkrTradeDetail,
  rollbackIbkrImports,
  rollbackIbkrImportVersion,
  deleteIbkrTrade,
  getIbkrImportsRefreshStatus,
  getIbkrImportRefreshStatus,
};
